// import React from "react";
// import "./backlogbool.css"

// function Backlogbool(){
//     return(
//         <div className="options-grid">
//      <label class="radio-button">
//     <input type="radio" name="option" value="1"></input>
//     <div class="radio-circle"></div>
//     <span class="radio-label">Yes</span>
//   </label>
//   <label class="radio-button">
//     <input type="radio" name="option" value="0"></input>
//     <div class="radio-circle"></div>
//     <span class="radio-label">No</span>
//   </label>
//         </div>
//     );
// }
// export default Backlogbool;

import React, { useState } from "react";
import "./backlogbool.css";
import { getSelectedYr } from "./calculations";


function Backlogbool() {
  const [hasBacklog, setHasBacklog] = useState(null);
  
    const handleChange = (e) => {
      const value = e.target.value;
      getSelectedYr(value);
      setHasBacklog(value);
      console.log("hasBacklog:", value); // For debugging
    };
  

  return (
    <div className="options-grid">
      <label className="radio-button">
        <input
          type="radio"
          name="option"
          value="1"
          onChange={handleChange}
        />
        <div className="radio-circle"></div>
        <span className="radio-label">Yes</span>
      </label>
      <label className="radio-button">
        <input
          type="radio"
          name="option"
          value="0"
          onChange={handleChange}
        />
        <div className="radio-circle"></div>
        <span className="radio-label">No</span>
      </label>
    </div>
  );
}


export default Backlogbool;

